import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/thin-lens-calculator',
  component: () => import('../../routes/ThinLensCalculator.svelte'),
  card: {
    id: 'thin-lens-calculator',
    title: 'Thin Lens Calculator',
    description: 'Calculate image distance, magnification, and focal length using the thin lens equation. Explore real and virtual images for converging and diverging lenses.',
    icon: 'panorama_fish_eye',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/thin-lens-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Thin Lens Calculator – Lens Equation Solver for Physics',
    description: 'Free thin lens calculator using 1/f = 1/do + 1/di. Calculate focal length, object distance, image distance, and magnification for converging and diverging lenses.',
  },
};

export default meta;